import React from 'react';

import { IReferee } from '../../../typings/player';
import { makeClassNames } from '../../../utils/styles';
import ReportTabsPanel, { IReportTabsPanel } from '../../molecules/report-tabs-panel/report-tabs-panel';
import TeamHeader from '../../molecules/team-header/team-header';
import { ITeam } from '../../molecules/team/team';
import MatchFormationField, { IMatchFormationField } from '../match-formation-field/match-formation-field';

import './match-startup-formation.scss';

import {
  getCourtesyMessage,
  getMatchFormationField,
  getReportTabsPanel,
  getTeamHeader,
} from './match-startup-formation-helpers';

export interface IMatchStartupFormation {
  teamField: IMatchFormationField;
  team: ITeam;
  referees?: IReferee[];
  isHome?: boolean;
}

const classNames = () =>
  makeClassNames({
    MatchStartupFormation: 'match-startup-formation',
    MatchFormationsWrapper: 'match-formations-wrapper',
    MatchFormations: 'match-formations',
  });

const MatchStartupFormation = ({ teamField, team, referees, isHome = true }: IMatchStartupFormation) => {
  const cn = classNames();

  const reportTabsPanel: IReportTabsPanel = isHome
    ? getReportTabsPanel(team)
    : getReportTabsPanel(undefined, team, referees);

  const matchFormationField = getMatchFormationField(teamField, isHome);
  const playersValid =
    matchFormationField.players?.length && matchFormationField.players.every((player) => player.fullName);

  return (
    <div className={cn.MatchStartupFormation}>
      <TeamHeader {...getTeamHeader(team, isHome)} />
      <div className={cn.MatchFormationsWrapper}>
        {playersValid && matchFormationField.formation ? (
          <MatchFormationField {...matchFormationField} />
        ) : (
          getCourtesyMessage()
        )}
        {matchFormationField.players?.length ? (
          <div className={cn.MatchFormations}>
            <ReportTabsPanel {...reportTabsPanel} />
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default MatchStartupFormation;
